module.exports = __webpack_public_path__ + "static/media/ITC-OfficinaSansITCPro-Book.cda6411c.ttf";